import Link from 'next/link';
import TitleUnderline from 'components/TitleUnderline';
import Typo from 'components/Typo';
import { alertPath } from 'utils/alert-url';
import { formatDate } from 'utils/newsroom';
import styles from 'styles/modules/MediaCoverage.module.scss';

export default function QuotedIn({ items, total, companySlug }) {
    if (!items?.length) {
        return null;
    }

    return (
        <div className="mb-l">
            <TitleUnderline className={'mb-m'}>
                <Typo Tag={'h2'} variant={'eyebrow'}>
                    Quoted in
                </Typo>
            </TitleUnderline>
            <ul className={styles.quotedIn}>
                {items.map((story) => (
                    <li key={story.slug}>
                        <Link href={alertPath(story.slug)}>
                            <a>{story.headline}</a>
                        </Link>
                        <time dateTime={story.publishedAt}>
                            {formatDate(story.publishedAt)}
                        </time>
                    </li>
                ))}
            </ul>
            {total > items.length && (
                <Link href={`/news?profile=${encodeURIComponent(companySlug)}`}>
                    <a className={styles.viewAll}>See all {total} stories</a>
                </Link>
            )}
        </div>
    );
}
